import PropTypes from 'prop-types';
import React from 'react';
import css from './ProfileHeaderMX.scss';
import UserBrand from './components/UserBrand';
import classNames from 'classnames';

export const ProfileHeaderOther = ({
    userImage,
    userName,
    locality,
    address,
    currentOpenState,
    operatingDetailsObject,
    operatingTime,
    operatingDays,
    profileLink,
    onClickProfile,
    latitude,
    longitude,
    sellerProfilePage,
    user,
    isClassified,
    meta,
    followers,
    following,
    userIsLogged,
    loggedUser,
    isCurrentlyOpen,
    coverImages
}) => {
    return (
        <div className={ classNames(css.profileHeader, { [css.modernProfileHeader]: isClassified }) } data-aut-id="sellerInfo" >
            <UserBrand
                userName={ userName }
                userImage={ userImage }
                sellerProfilePage={ sellerProfilePage }
                profileLink={ profileLink }
                locality={ locality }
                onClickProfile={ onClickProfile }
                user={ user }
                isClassified={ isClassified }
                meta={ meta }
                followers={ followers }
                following={ following }
                userIsLogged={ userIsLogged }
                loggedUser={ loggedUser }
                address={ address }
                latitude={ latitude }
                longitude={ longitude }
                showDirectionsCTA={ true }
                currentOpenState={ currentOpenState }
                operatingTime={ operatingTime }
                operatingDays={ operatingDays }
                operatingDetailsObject={ operatingDetailsObject }
                coverImages={ coverImages }
                isCurrentlyOpen={ isCurrentlyOpen }
            />
        </div>
    );
};

ProfileHeaderOther.propTypes = {
    userImage: PropTypes.string,
    userName: PropTypes.string,
    locality: PropTypes.string,
    address: PropTypes.string,
    currentOpenState: PropTypes.string,
    operatingDetailsObject: PropTypes.object,
    operatingTime: PropTypes.string,
    operatingDays: PropTypes.string,
    profileLink: PropTypes.string,
    onClickProfile: PropTypes.func,
    latitude: PropTypes.string,
    longitude: PropTypes.string,
    sellerProfilePage: PropTypes.bool,
    user: PropTypes.object,
    isClassified: PropTypes.bool,
    config: PropTypes.shape({
        get: PropTypes.func.isRequired
    }),
    meta: PropTypes.func,
    followers: PropTypes.array,
    following: PropTypes.array,
    userIsLogged: PropTypes.bool,
    loggedUser: PropTypes.object,
    isCurrentlyOpen: PropTypes.bool,
    coverImages: PropTypes.array
};

ProfileHeaderOther.defaultProps = {
    userImage: '',
    userName: '',
    locality: '',
    address: '',
    currentOpenState: '',
    operatingDetailsObject: {},
    operatingTime: '',
    operatingDays: '',
    profileLink: '',
    onClickProfile: () => {},
    latitude: '',
    longitude: '',
    sellerProfilePage: false,
    user: {},
    isClassified: false
};

export default ProfileHeaderOther;
